import { Component, ChangeDetectionStrategy, ContentChild, ChangeDetectorRef } from '@angular/core';
import { AmdInputDirective } from '../input/input.directive';
var AmdInputContainerComponent = /** @class */ (function () {
    /**
     * @param {?} changeDetectorRef
     */
    function AmdInputContainerComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this._isFocussed = false;
    }
    Object.defineProperty(AmdInputContainerComponent.prototype, "isFocussed", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isFocussed;
        },
        /**
         * @param {?} isFocussed
         * @return {?}
         */
        set: function (isFocussed) {
            this._isFocussed = isFocussed;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdInputContainerComponent.prototype.focus = function () {
        this.isFocussed = true;
        this.input.setFocus(true);
    };
    /**
     * @return {?}
     */
    AmdInputContainerComponent.prototype.blur = function () {
        this.isFocussed = false;
        this.input.setFocus(false);
    };
    /**
     * @return {?}
     */
    AmdInputContainerComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (!this.input) {
            throw new Error('amdInput is required as a child of amdInputContainer');
        }
        this.input.isFocussedChange.subscribe(function (isFocussed) { return _this.isFocussed = isFocussed; });
    };
    AmdInputContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-input-container',
                    template: "<span class=\"amd-input-container\" [class.amd-input-container--focussed]=\"isFocussed\"> <ng-content></ng-content> </span>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdInputContainerComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef, },
    ]; };
    AmdInputContainerComponent.propDecorators = {
        'input': [{ type: ContentChild, args: [AmdInputDirective,] },],
    };
    return AmdInputContainerComponent;
}());
export { AmdInputContainerComponent };
function AmdInputContainerComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputContainerComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputContainerComponent.ctorParameters;
    /** @type {?} */
    AmdInputContainerComponent.propDecorators;
    /** @type {?} */
    AmdInputContainerComponent.prototype._isFocussed;
    /** @type {?} */
    AmdInputContainerComponent.prototype.input;
    /** @type {?} */
    AmdInputContainerComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=input-container.component.js.map
//# sourceMappingURL=input-container.component.js.map
